import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import PrimaryButton from '../../jsx/components/button/primaryButton'

const FcmTokenVerify = ({ FcmModalTrigger, handleCloseFCM, titleTXT, bodyTXT }) => {
    return (
        <>
            {/* <!-- Modal --> */}
            <Modal className="fade" show={FcmModalTrigger}
            // onHide={handleCloseCallDetails}
            >
                <Modal.Header style={{ borderBottom: 'none' }}>
                    <Modal.Title>
                        {titleTXT}
                    </Modal.Title>
                    <Button
                        variant=""
                        className="call-btn-close btn-close"
                        // onClick={() => setBasicModal(false)}
                        onClick={() => handleCloseFCM()}
                    >
                    </Button>
                </Modal.Header>


                <Modal.Body>
                    <p style={{fontSize:'18px', fontWeight:'600', color:'black'}}>{bodyTXT}</p>

                    <div className='d-flex align-items-center' style={{justifyContent:'flex-end'}}>
                        <PrimaryButton 
                            buttonName={"Ok"}
                            onClick={() => handleCloseFCM()}
                        />
                    </div>

                </Modal.Body>
            </Modal>
        </>
    )
}

export default FcmTokenVerify